import { ComponentPropsWithoutRef, FC } from "react";
import { useInViewVideo } from "../hooks/useInViewVideo";
import EmptyCaptionsTrack from "./EmptyCaptionsTrack";

type ShortsStackProps = ComponentPropsWithoutRef<"div">;

const ShortsStack: FC<ShortsStackProps> = ({ ...rest }) => {
  const videoRef = useInViewVideo<HTMLVideoElement>();
  return (
    <div {...rest} className={`flex gap-4 relative ${rest.className}`}>
      <div
        className={`w-14 absolute aspect-[9/16] bg-slate-100 rounded-xl top-5 right-5`}
      ></div>
      <div
        className={`w-14 absolute aspect-[9/16] bg-slate-200 rounded-xl top-2.5 right-2.5`}
      ></div>
      <div
        className={`w-14 h-full aspect-[9/16] bg-slate-300 rounded-xl z-10 overflow-hidden mb-5 ml-5`}
      >
        {/* Lighthouse `image-delivery-insight` flags this poster (203x360
            served, 112x199 displayed). Same treatment as the hero poster:
            keep the URL but hint the rendered dimensions so the browser can
            short-circuit layout work. A pre-resized variant should be
            uploaded to storage.googleapis.com when convenient. */}
        <video
          ref={videoRef}
          width={112}
          height={199}
          src="https://assets.klap.app/web-assets/360_emma_4.mp4"
          poster="https://storage.googleapis.com/klap-assets/web-assets/poster_emma_4.jpg"
          muted
          loop
          playsInline
          preload="none"
          className="h-full w-full"
        >
          <EmptyCaptionsTrack />
        </video>
      </div>
    </div>
  );
};

export default ShortsStack;
